import React, { useContext } from 'react';
import { compact } from 'lodash';
import { routes } from 'constants/config';
import { FilterContext } from 'components/shared/FilterContext';
import SatisfactionChart from './SatisfactionChart';
import RatedLessonRow from './RatedLessonRow';
import RatingsCounts from './RatingsCounts';
import DataCardHeader from '../_shared/DataCardHeader';
import DataCardTitle from '../_shared/DataCard/Title';
import InsightsTable from '../_shared/InsightsTable';
import { formatDateRange } from '../_shared/DateRangeFormat';

const RatingsModule = ({ i18n }) => {
  const { params: filterParams } = useContext(FilterContext);

  const hasDateFilter = filterParams.start_date || filterParams.end_date;

  const learnerSatisfactionTooltip = hasDateFilter
    ? t('insights.ratings.learner_satisfaction.description_with_filters')
    : t('insights.ratings.learner_satisfaction.description');

  const topRatedTooltip = hasDateFilter
    ? t('insights.ratings.top_rated.description_with_filters')
    : t('insights.ratings.top_rated.description');

  const lowestRatedTooltip = hasDateFilter
    ? t('insights.ratings.lowest_rated.description_with_filters')
    : t('insights.ratings.lowest_rated.description');

  const dateLabel = hasDateFilter
    ? formatDateRange(filterParams.start_date, filterParams.end_date)
    : i18n.timeframes.last_90_days;

  const ratingsSubtitle = hasDateFilter
    ? t('insights.ratings.table_subtitle_with_filter', {
        date: formatDateRange(filterParams.start_date, filterParams.end_date),
      })
    : t('insights.ratings.table_subtitle');

  return (
    <section className="DataCard">
      <DataCardHeader
        title={i18n.ratings.lesson_ratings.title}
        subtitle={dateLabel}
        downloadLink={compact([
          routes.INSIGHTS.RATINGS.REPORT,
          $.param(filterParams),
        ]).join('?')}
        reportTitle={i18n.ratings.lesson_ratings.report.title}
        pendoClassName="trk_link_learning_all-lesson-ratings-download"
      >
        <RatingsCounts i18n={i18n} />
      </DataCardHeader>
      <div className="DataCard-main">
        <DataCardTitle
          title={i18n.ratings.learner_satisfaction.title}
          tooltip={learnerSatisfactionTooltip}
          subtitle={dateLabel}
        />
        <SatisfactionChart i18n={i18n} />
        <InsightsTable
          title={i18n.ratings.top_rated.title}
          tooltip={topRatedTooltip}
          subtitle={ratingsSubtitle}
          source={compact([
            routes.INSIGHTS.RATINGS.HIGHEST_RATED_LESSONS,
            $.param(filterParams),
          ]).join('?')}
          rowComponent={RatedLessonRow}
          i18n={i18n}
        />
        <InsightsTable
          customClass="mt-32"
          title={i18n.ratings.lowest_rated.title}
          tooltip={lowestRatedTooltip}
          subtitle={ratingsSubtitle}
          source={compact([
            routes.INSIGHTS.RATINGS.LOWEST_RATED_LESSONS,
            $.param(filterParams),
          ]).join('?')}
          rowComponent={RatedLessonRow}
          i18n={i18n}
        />
      </div>
    </section>
  );
};

export default RatingsModule;
